const ListColumn = () => {};

ListColumn.defaultProps = {
  visible: true,
};

export default ListColumn;
